import { Typography } from "@mui/material";

const HeaderText = ({
  variant,
  fontSize = "3.5rem",
  textContent,
  fontWeight = "500",
  lineHeight = "normal",
  textAlign = "-webkit-auto",
  color,
  paddingBottom
}) => {
  return (
    <Typography
      variant={variant}
      color={color && color}
      textAlign={textAlign}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      paddingBottom={paddingBottom}
    >
      {textContent}
    </Typography>
  );
};

export default HeaderText;
